import { css } from 'lit';

export default css`
  amityeko-empty-view {
    display: block;
    height: 376px;
  }
`;
